import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/image/empty.webp'
import _imports_1 from '@/assets/image/empty.jpg'


const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "card-detail" }
const _hoisted_3 = { class: "card-detail__img" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "card-detail__info"
}
const _hoisted_9 = { class: "card-detail__title" }
const _hoisted_10 = { class: "card-detail__down" }
const _hoisted_11 = { class: "card-detail__down-prices" }
const _hoisted_12 = {
  key: 0,
  class: "card-detail__down-price-old"
}
const _hoisted_13 = { class: "card-detail__down-price-new" }
const _hoisted_14 = {
  key: 0,
  class: "card-detail__down-price-tag"
}
const _hoisted_15 = { class: "animation-btn" }

import { priceFormat } from "@/helpers/priceFormat";
import ChangeBasket from "./ChangeBasket.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CardDetail',
  props: ["data"],
  setup(__props) {

  const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      (__props.data.images.length != 0)
        ? (_openBlock(), _createElementBlock("picture", _hoisted_4, [
            _createElementVNode("source", {
              srcset: 'https://akshop.a-dev.xyz' + __props.data.images[0]
            }, null, 8, _hoisted_5),
            _createElementVNode("img", {
              src: 'https://akshop.a-dev.xyz' + __props.data.images[0],
              alt: __props.data.name,
              loading: "eager"
            }, null, 8, _hoisted_6)
          ]))
        : (_openBlock(), _createElementBlock("picture", _hoisted_7, _cache[0] || (_cache[0] = [
            _createElementVNode("source", { srcset: _hoisted_1 }, null, -1),
            _createElementVNode("img", {
              src: _imports_1,
              alt: "Нет фото",
              loading: "eager"
            }, null, -1)
          ])))
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "card-detail__info-value" }, "В наличии: 18 шт", -1),
          _createElementVNode("div", { class: "card-detail__info-text" }, "399.99 ₽/кг", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, _toDisplayString(__props.data.name), 1),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "109.90 ₽ /шт"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createTextVNode(_toDisplayString(_unref(priceFormat)(__props.data.basePrice)) + " ", 1),
          (__props.data.measure == 'кг' && false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 1 кг "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(ChangeBasket, { source: __props.data }, null, 8, ["source"])
      ])
    ])
  ]))
}
}

})